import type { IConfSolicitudEntidad } from '@/modules/Configuracion/interfaces'
import { BaseService } from '@/modules/Core/services/BaseService'

export class EntidadSolicitudService extends BaseService<IConfSolicitudEntidad> {
  constructor () {
    super({
      baseUrl: 'system/entities-request/'
    })
  }
}
